import * as React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'tabler-react';
import toast from 'cogo-toast';
import Request from '../../shared/request';
import AlipaySvg from '../../assets/ic_alipay.svg';
import PaypalSvg from '../../assets/ic_paypal.svg';
import i18n from '../../shared/i18n';

class Withdrowal extends React.Component {
  state = {
    paytype: 'paypal',
    account: '',
    idname: '',
  };

  constructor(props) {
    super(props);
    const { idname, account, paytype } = this.props.affWithdrawAccount || {};
    if (idname) {
      this.state.idname = idname;
    }
    if (account) {
      this.state.account = account;
      this.state.exists = true;
    }
    if (paytype) {
      this.state.paytype = paytype;
    }
  }

  handleWithdrowal = async () => {
    if (!['paypal', 'alipay'].includes(this.state.paytype)) {
      toast.warn(i18n.t('dash-aff-paynotsupport'));
      return;
    }
    if (!this.state.account) {
      toast.warn(i18n.t('dash-aff-accountalert'));
      return;
    }
    if (!this.state.idname) {
      toast.warn(i18n.t('dash-aff-namealert'));
      return;
    }
    const res = await Request.call('saveWithdrawAffAccount', {
      paytype: this.state.paytype,
      account: this.state.account,
      idname: this.state.idname,
    });
    if (res && res.paytype) {
      toast.success(i18n.t('dash-aff-updateok'));
    }
    const modalEl = document.getElementById('modal');
    const rootEl = document.getElementById('root');
    if (modalEl) {
      rootEl.removeChild(modalEl);
    }
    this.props.refreshAmount();
  };

  render() {
    return (
      <div className="withdrowal-setting">
        <div className="account-info">
          <h4>{i18n.t('dash-aff-overview')}</h4>
          <div className="payment-type">
            <div
              onClick={() => this.setState({ paytype: 'paypal' })}
              className={`${this.state.paytype === 'paypal' ? 'active' : ''}`}>
              <img src={PaypalSvg} alt="paypal" />
              <span>Paypal</span>
            </div>
            <div
              className={`${this.state.paytype === 'alipay' ? 'active' : ''}`}>
              <img src={AlipaySvg} alt="alipay" />
              <span style={{ color: '#999' }}>{i18n.t('dash-aff-alipay')}</span>
            </div>
          </div>
          <div className="account">
            <div className="form-wrapper account-name">
              <div className="label">{i18n.t('dash-aff-account')}</div>
              <input
                type="text"
                placeholder={i18n.t('dash-aff-accountalert')}
                value={this.state.account}
                onChange={e => this.setState({ account: e.target.value })}
              />
            </div>

            <div className="form-wrapper">
              <div className="label">Name</div>
              <input
                type="text"
                value={this.state.idname}
                placeholder={i18n.t('dash-aff-namealert')}
                onChange={e => this.setState({ idname: e.target.value })}
              />
            </div>
          </div>
        </div>
        <div className="desc">
          <h4>{i18n.t('dash-aff-moneyrule')}</h4>
          <li>{i18n.t('dash-aff-moneyrule1')}</li>
          <li>{i18n.t('dash-aff-moneyrule2')}</li>
          <Button onClick={this.handleWithdrowal} pill color="primary">
            {this.state.exists ? i18n.t('dash-aff-updateauto') : i18n.t('dash-aff-enableauto')}
          </Button>
        </div>
      </div>
    );
  }
}

Withdrowal.propTypes = {
  affWithdrawAccount: PropTypes.object,
  refreshAmount: PropTypes.func,
};

export default Withdrowal;
